
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M10.065 0a.51.51 0 000 1.02c4.989 0 9.047 4.057 9.047 9.045 0 4.989-4.058 9.047-9.047 9.047-4.988 0-9.046-4.058-9.046-9.047a.51.51 0 00-1.019 0c0 5.55 4.515 10.066 10.065 10.066s10.066-4.516 10.066-10.066C20.13 4.515 15.615 0 10.065 0z"}}),_c('path',{attrs:{"d":"M15.267 4.864c-2.868-2.869-7.535-2.869-10.403 0-2.869 2.868-2.869 7.535 0 10.403a.51.51 0 10.72-.72 6.345 6.345 0 010-8.963 6.345 6.345 0 018.963 0 6.345 6.345 0 010 8.963.51.51 0 10.72.72c2.869-2.868 2.869-7.535 0-10.403zM23.804 23.083l-6.37-6.37a.51.51 0 10-.721.72l6.37 6.37a.508.508 0 00.72 0 .51.51 0 000-.72z"}})])])
          )
        }
      }
    